import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Axios from '@/axiosPool';
import Select from '@/components/common/Select/Select';
@connect((store) => {
  return {
    common: store.common,
    loggedUser: store.loggedUser,
  };
})
class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      keyword: null,
      isLoading: false,
      isClose: false,
      options: [],
      selected: null,
    };

    _.map(['onFetch', 'onChange', 'onRenderOption'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  onFetch(page = 1, q = '') {
    const params = {
      page: page,
      limit: 10,
      project: q,
    };

    this.setState({
      ...this.state,
      isLoading: true,
    });

    Axios.get('api/project/getUserProject', params).then((response) => {
      if (response) {
        this.setState({
          ...this.state,
          isLoading: false,
          options: response.data.result.map((r) => ({
            value: r.id,
            label: r.project,
            link: `account#/projects/${r.id}`,
            color: r.color,
          })),
        });
      }
    });
  }

  onChange(option) {
    this.setState(
      {
        ...this.state,
        selected: option,
      },
      () => {
        window.location.replace(`/account#/projects/${option.value}`);
      }
    );
  }

  onRenderOption(option) {
    return (
      <div class="account-item">
        <div
          class="account-status"
          style={{ backgroundColor: option.color }}
        ></div>
        <div class="account-name">
          <span>
            {option.label.length > 22
              ? `${option.label.substring(0, 22)}...`
              : option.label}
          </span>
        </div>
      </div>
    );
  }

  render() {
    const onSearch = _.debounce((q) => {
      this.onFetch(1, q);
    }, 500);

    return (
      <div class="search-projects">
        <Select
          classes={{ options: 'searchDropdownContainer' }}
          isSearchable={true}
          isLoading={this.state.isLoading}
          isClose={this.state.isClose}
          onOpen={(q) => this.onFetch(1, q)}
          onSearch={onSearch}
          options={this.state.options}
          searchIcon={<i class="material-icons">search</i>}
          clearIcon={<i class="material-icons">cancel</i>}
          onChange={this.onChange}
          selected={this.state.selected}
          renderOption={this.onRenderOption}
          link={true}
        />
      </div>
    );
  }
}

export default Search;
